import React from 'react';
import { withRouter } from 'react-router-dom';
import moment from 'moment';

import styles from './SiteFooter.scss';

function SiteFooter(props) {
  const { location } = props;

  if (location.pathname === '/') {
    return null;
  }

  return (
    <footer className={styles.footer}>©Potion {moment().format('YYYY')}</footer>
  );
}

export default withRouter(SiteFooter);



// WEBPACK FOOTER //
// ./src/components/SiteFooter/SiteFooter.jsx